import React from 'react';
import { Row, Divider } from 'antd';
import { FormattedMessage } from 'react-intl';

import LoginLink from './LoginLink';

interface Props {
  datevOauthUri: string;
}

const LoginView: React.FC<Props> = ({ datevOauthUri }) => (
  <>
    <FormattedMessage
      defaultMessage="<h1>To connect your DATEV Kassenarchiv online with Shore POS please follow these steps:</h1>"
      values={{ h1: (m: React.ReactNode[]) => <h1>{m}</h1> }}
    />
    <ol>
      <FormattedMessage
        defaultMessage="<li>Press “Open DATEV Login”</li> <li>You will be forwarded to the Login page of DATEV Kassenarchiv</li> <li>Enter your DATEV Kassenarchiv online credentials</li> <li>Confirm the consent page</li> <li>You will be re-directed to the connect dashboard and you have successfully connected DATEV Kassenarchivonline</li> "
        values={{ li: (m: React.ReactNode[]) => <li>{m}</li> }}
      />
    </ol>
    <Divider />
    <Row justify="center">
      <LoginLink oauthUri={datevOauthUri} />
    </Row>
  </>
);

export default LoginView;
